import { fromJS } from 'immutable';

import {
    META_STORE_STATUS,
    META_STORE_FORM,
    META_CLEAR_SOBJECT,
    META_STORE_SOBJECT_NAME,
    META_STORE_SOBJECT_FIELDS,
    META_STORE_FEED_ID,
    META_STORE_UPDATE_DUPES,
    META_STORE_IDENTITY_FIELD,
    META_UPDATE_DUPES_HYDRATE,
} from './actions';

/** Meta Store **/
const metaInitialState = fromJS({
    form: null,
    sobject: {
        name: '',
        fields: null
    },
    feed_id: null,
    status: null,
    update_dupes: {}
});

export const metaReducer = function (state = metaInitialState, action) {
    switch (action.type) {
        case META_UPDATE_DUPES_HYDRATE:
            return state.set('update_dupes', fromJS(action.update_dupes));

        case META_STORE_UPDATE_DUPES:
        {
            const { enabled, sobjectName } = action;

            let newState = state.toJS();

            if (!newState.update_dupes.hasOwnProperty(sobjectName)) {
                newState.update_dupes[sobjectName] = {};
            }

            newState.update_dupes[sobjectName].enabled = enabled;

            return fromJS(newState);
        }

        case META_STORE_IDENTITY_FIELD:
        {
            const { identity_field, sobjectName } = action;

            let newState = state.toJS();

            if (!newState.update_dupes.hasOwnProperty(sobjectName)) {
                newState.update_dupes[sobjectName] = {};
            }

            newState.update_dupes[sobjectName].identity_field = identity_field;

            return fromJS(newState);
        }

        case META_STORE_STATUS:
            return state.set('status', action.status);

        case META_STORE_FORM:
            return state.set('form', fromJS(action.form));

        case META_CLEAR_SOBJECT:
            return state.mergeDeep(fromJS({
                sobject: {
                    name: '',
                    fields: null
                }
            }));

        case META_STORE_SOBJECT_NAME:
            return state.mergeDeep(fromJS({
                sobject: {
                    name: action.name
                }
            }));

        case META_STORE_SOBJECT_FIELDS:
            return state.mergeDeep(fromJS({
                sobject: {
                    fields: action.fields
                }
            }));
        case META_STORE_FEED_ID:
            return state.set('feed_id', action.feed_id);
    }

    return state;
}
